import { render, staticRenderFns } from "./VehicleHistoryDetails.vue?vue&type=template&id=2dbe065a&scoped=true"
import script from "./VehicleHistoryDetails.vue?vue&type=script&lang=js"
export * from "./VehicleHistoryDetails.vue?vue&type=script&lang=js"
import style0 from "./VehicleHistoryDetails.vue?vue&type=style&index=0&id=2dbe065a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbe065a",
  null
  
)

export default component.exports